/*
 * @Author: zhangyuan zhangyuan@cheyipai.com
 * @Date: 2022-08-24 16:07:02
 * @LastEditors: zhangyuan your_email
 * @LastEditTime: 2025-09-26 11:27:24
 * @FilePath: /report-template/src/service/index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from './axios';
import md5 from "js-md5";

const {VUE_APP_FINSNCE_JSON_URL, VUE_APP_FINSNCE_URL, VUE_APP_DANUBE} = process.env
// 根据配置获取报告数据
export const GetReportFromServe = (data: any) => {
    const {reportCode, templateCode, reportVersion, regenerate, originTemplateCode, lang} = data;
    let url = `${VUE_APP_FINSNCE_URL}/detect/report/reportConfigurableApi/getReport`
    return axios({
        method: 'get',
        url,
        data: {
            reportVersion,
            reportCode,
            templateCode,
            regenerate: regenerate || 1,
            originTemplateCode,
            lang
        }
    })
}
/**
 * 获取静态化配置报告数据
 * */
export const GetReportFromJSON = (data: any) => {
    const {reportCode, reportVersion, templateCode, lang} = data;

    let str = reportCode.toLowerCase() + reportVersion.toLowerCase();
    if(lang && lang !== 'null' && lang !== 'undefined') {
        str += lang.toLowerCase();
    }
    let md5S = md5(str);
    let md5String = md5S.substring(md5S as any, 4);
    let url;
    if(templateCode){
        url = (`${VUE_APP_FINSNCE_JSON_URL}/report268v/${md5String}/${reportVersion}/${reportCode}_getReport${templateCode}${lang||''}.json`).toLowerCase()
    }else{
        url = (`${VUE_APP_FINSNCE_JSON_URL}/report268v/${md5String}/${reportVersion}/${reportCode}_getReport${lang || ''}.json`).toLowerCase()
    }
    return axios({
        method: 'get',
        url,
        timeout: 10000,
        isStatic: true,
        resHasData: true
    });
}
// 根据styleCode获取检测标准
export const GetCheckStandards = (data: any) => {
    const {styleCode} = data;
    let url = `${VUE_APP_FINSNCE_URL}/detect/config/reportTemplateApi/getCheckStandards`
    return axios({
        method: 'get',
        url,
        resHasData: true,
        data: {
            styleCode,
        }
    })
}
/**
 * 是否冲销
 * */
export const GetVerifyEffectiveReport = (data: any) => {
    const {reportCode} = data;
    let url = `${VUE_APP_DANUBE}/detect/detectInfoAction/cyp/verifyEffectiveReport.json`
    return axios({
        method: 'get',
        url,
        data: {
            reportCode
        }
    });
}
/**
 * 是否需要跳转到车况报告
 * */
export const GetCheKuangReportUrl = (data: any) => {
    const {reportCode, templateCode} = data;
    let url = `${VUE_APP_FINSNCE_URL}/detect/report/reportApi/getCheKuangReportUrl`
    return axios({
        method: 'get',
        url,
        data: {
            reportCode,
            templateCode
        }
    });
}
/**
 * 是否过期
 * */
export const GetExpireReportUrl = (data: any) => {
    // const {reportCode, templateCode} = data;
    let url = `${VUE_APP_FINSNCE_URL}/detect/report/reportConfigurableApi/getExpireReport`
    return axios({
        method: 'get',
        url,
        data
    });
}


/**
 * 获取阿里云视频auth
 * */
export function getVideoPlayAuth(opts) {
    let url = `${VUE_APP_FINSNCE_URL}/detect/report/reportApi/getVideoPlayAuth?videoId=${opts.videoId}`;
    return axios({
        method: 'get',
        url
    });
}



